<template>
    <div class="activityOutcomeContainer" :class="addPrintClass()">

      <div>
        <!-- Show all attempts -->
        <div class="section_head">Attempts Summary</div>

        <table class="attempts_summary_table">
        	<tr>
        		<th>Attempt #</th>
        		<th>Date and Time <br/> of Attempt</th>
			      <th>Result</th>
			      <th>Report</th>
        	</tr>
          <tr v-for="(myattempt, index) in myattempts">
          	<td>{{index + 1}}</td>
          	<td>{{ getFormattedDateTime(myattempt.startTime) }}</td>
            	<td style="min-width: 100px"><span class="icon_success" :id="'stat_' + index" :class="gradeStatus1('stat_' + index, myattempt.score, myattempt.maxScore)"></span>{{myattempt.score}} / {{myattempt.maxScore}} </td>
            	<td>
              	<b-btn variant="primary" size="lg" v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)" @click="showLearnosityReport(myattempt, myattempt.activityId, myattempt.sessionId)">Show Report</b-btn>
              	<span v-else>Grade Pending</span>
            	</td>
          </tr>
        </table>
      </div>

  		<b-modal ref="learnosityStudentReportModal" centered size="lg" class="learnosity-student-report-modal" hide-footer>
  			<span class="learnosity-report" id="sessionDetailByItemReport"></span>
        <div class="print_msg">
          Print is not available
        </div>
  		</b-modal>

    </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import { mapActions,mapState } from 'vuex'
  export default {
    name: 'activityOutcome',
    props: ['entityId', 'courseId', 'userId'],

    data () {
      return {
        myattempts: [],
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    mounted () {
      this.loadAssessmentDetail()
    },

    methods: {
      ...mapActions([
        'loadAssessment2',
        'showAttemptReport',
        'launchManuallyGradedReportWizardForUser',
        'loadLogDashboardActivity'
      ]),

      getFormattedDateTime (timeInMillis, showOnlyDate) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        if (!showOnlyDate) {
          var amPm = ''
          var currHour = d.getHours()
          if (currHour < 12) {
            amPm = 'AM'
          } else {
            amPm = 'PM'
          }
          if (currHour === 0) {
            currHour = 12
          }
          if (currHour > 12) {
            currHour = currHour - 12
          }
          var currMin = d.getMinutes()
          currMin = currMin + ''
          if (currMin.length === 1) {
            currMin = '0' + currMin
          }
          var currSec = d.getSeconds()
          currSec = currSec + ''
          if (currSec.length === 1) {
            currSec = '0' + currSec
          }
          str += ' ' + currHour
          str += ':' + currMin
          str += ':' + currSec
          str += ' ' + amPm
        }
        return str
      },

      gradeStatus1 (entity, minscore, maxscore) {
        setTimeout(() => {
          var gradeClass = 'noGrade'
          var performance = parseFloat((minscore / maxscore) * 100).toFixed(2)
          if (performance >= 90) {
            gradeClass = 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            gradeClass = 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            gradeClass = 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            gradeClass = 'gradeD'
          } else if (performance < 40) {
            gradeClass = 'gradeE'
          }
          $('#' + entity).addClass(gradeClass)
        }, 100)
      },

      loadAssessmentDetail () {
        this.loadAssessment2({uuid: this.entityId, userId: this.userId}).then((response) => {
          const data = { ...response }
          this.myattempts = data.attempt
          if (this.myattempts && this.myattempts.length > 0) {
            this.attempt = this.myattempts[0]
          }
        })
      },

      showLearnosityReport (myattempt, activityId, sessionId, isManuallyGraded) {
        this.loadLogDashboardActivity({action: 'clickKnowlegdeCheckReport', page: 'courseReport', link: '', entityUuid: this.courseId})
        this.attempt = myattempt
        this.$refs.learnosityStudentReportModal.doShow()
        this.showAttemptReport({activityId: activityId, sessionId: sessionId, courseId: this.courseId, userId: this.userId}).then(data => {
          if (data) {
            this.initializeLearnosityReports(data)
          }
        })
      },
      addPrintClass () {
        if (this.isPrintDisable()) {
          return 'no_print_win'
        } else {
          return ''
        }
      },
      initializeLearnosityReports (data) {
        var self = this
        self.reportsApp = LearnosityReports.init(data, {
          'readyListener': function () {
            if (self.attempt.manuallyGraded) {
              self.bindReadyListener()
            }
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },
    isPrintDisable () {
      if (this.enabledFeatures && this.enabledFeatures['disablePrint']) {
        return this.enabledFeatures['disablePrint'].enabled
      }
      return false
    },

      bindReadyListener () {
        var itemReferences = []
        var report = this.reportsApp.getReport('sessionDetailByItemReport')
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference
                this.scoringObjects[itemId] = question
                itemReferences.push({'id': itemId, 'reference': reference})

                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row')).wrap('<div class="col-md-6"></div>')
              }
            })
          })

          if (itemReferences.length > 0) {
            var itemsActivity = {
              'state': 'review',
              'type': 'feedback',
              'items': itemReferences,
              'rendering_type': 'inline',
              'session_id': this.attempt.sessionId,
              'activity_id': this.attempt.activityId
            }

            this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
              if (data) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(data, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                  }
                })
              }
            })
          }
        })
      },

      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + ((question.validation && question.validation.max_score) ? question.validation.max_score : 1)
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      }
    },
      computed: {
    ...mapState({
      'enabledFeatures': state => state.institution.enabledFeatures
    }),

    }
  }
</script>

<style scoped>
    .activityOutcomeContainer {
        width: 90%;
    }
</style>



// WEBPACK FOOTER //
// src/app/assessment/components/ActivityOutcome.vue